<template>
    <div>
        <b-icon v-if="iconType == 'b-icon'" :icon="iconValue"></b-icon>
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String
        }
    },

    computed: {
        iconType() {
            const part = this.icon.split(':')

            return part[0]
        },

        iconValue() {
            const part = this.icon.split(':')

            return part[1]
        }
    }
}
</script>